import { useState } from 'react';
import { Button } from '@mui/material';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

const StripeCheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true);
    try {
      const { error } = await stripe.confirmPayment({
        confirmParams: {
          return_url: window.location.href
        },
        elements
      });
      if (error) {
        setError(error.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (!stripe) return null;

  return (
    <>
      <PaymentElement />
      <Button color="secondary" disabled={loading} onClick={handleSubmit} style={{ marginTop: '15px' }} variant="contained">
        Pagar
      </Button>
      {error && <div>{error}</div>}
    </>
  );
};

export default StripeCheckoutForm;
